import $ from 'jquery';
$(document).ready(function () {
    function updateSliderClass() {
        if (window.innerWidth <= 480) {
            $('.cardBlocks .slider').removeClass('row');
        }
        else {
            $('.cardBlocks .slider').addClass('row');
        }
    }
    function initSlider() {
        if (window.innerWidth <= 480) {
            if (!$('.cardBlocks .slider').hasClass('slick-initialized')) {
                const $slider = $('.cardBlocks .slider');
                $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                    const i = (currentSlide || 0) + 1;
                    const progressWidth = (i / slick.slideCount) * 100;
                    $('.cardBlocks .progress-bar').css('width', progressWidth + '%');
                });
                $slider.slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    mobileFirst: true,
                    arrows: false,
                    centerMode: true,
                    variablewidth: true
                });
            }
        }
        else {
            if ($('.cardBlocks .slider').hasClass('slick-initialized')) {
                $('.cardBlocks .slider').slick('unslick');
            }
        }
    }
    function setSlideVisibility() {
        const $carousel = $('.cardBlocks .slider');
        const visibleSlides = $carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
        $(visibleSlides).each(function () {
            $(this).css('opacity', 1);
        });
        $(visibleSlides).first().prev().css('opacity', 0);
    }
    function adjustCardHeights() {
        $('.cardBlocks .slider').each(function () {
            let maxHeight = 0;
            const cardsInRow = $(this).find('.storyInfo');
            cardsInRow.css('height', 'auto');
            cardsInRow.each(function () {
                const cardHeight = $(this).outerHeight();
                if (cardHeight > maxHeight) {
                    maxHeight = cardHeight;
                }
            });
            cardsInRow.css('height', maxHeight);
        });
    }
    function addClassIfAuthorInfoExists() {
        if ($('.cardBlocks .save.has-spacing').length > 0) {
            $('section.cardBlocks').addClass('noCollapse');
        }
        if ($('.author-info .text-date.press-release').length > 0) {
            $('a.arrow-link.cta-right').addClass('cta-date');
        }
    }
    function addClassOnBgChange() {
        $('.cardBlocks .col-md-4').each(function () {
            const hoverElement = $(this).find('.hover-content');
            const lineElement = $(this).find('.storyInfo');
            const $bgColor = hoverElement.css('backgroundColor');
            if ($bgColor === 'rgb(245, 245, 247)') {
                $(hoverElement).addClass('grey-color');
                $(lineElement).addClass('grey-color');
            }
            else if ($bgColor === 'rgb(0, 112, 173)') {
                $(hoverElement).addClass('blue-color');
                $(lineElement).addClass('blue-color');
            }
            else if ($bgColor === 'rgb(32, 32, 32)') {
                $(hoverElement).addClass('black-color');
                $(lineElement).addClass('black-color');
            }
            else if ($bgColor === 'rgb(245, 59, 83)') {
                $(hoverElement).addClass('red-color');
                $(lineElement).addClass('red-color');
            }
        });
    }
    updateSliderClass();
    initSlider();
    adjustCardHeights();
    setSlideVisibility();
    addClassIfAuthorInfoExists();
    addClassOnBgChange();
    $(window).resize(function () {
        updateSliderClass();
        initSlider();
        adjustCardHeights();
        setSlideVisibility();
        addClassIfAuthorInfoExists();
        addClassOnBgChange();
    });
});
